<template>
  <main class="main-wrap">
    <div class="topChart-wrap">
      <CommonContainer
        class="analysis"
        :scale="styleContainer.topChartStyle"
        :title='$store.state.barTitle'
        @handleTypesSelect="handleTypesSelected"
        @change="changeisShowChart"
      >
        <!-- <template slot-scope="scope">
          <LineChart
            ref="政策法规"
            :line-data="categoryData.政策法规"
            :line-mode="'link'"
            :is-show-legend-default="scope.chartStatus.isShowEnlargedChart"
            v-if="scope.chartStatus.isShowChart"
          ></LineChart>
          <DetailTable
            :type-list="checkedSubcategoryNameList.政策法规"
            :table-data="tableData.政策法规"
            v-else
          ></DetailTable>
        </template> -->
        <BarEcharts  :echartsList="$store.state.barchartsList"></BarEcharts>
      </CommonContainer>

      <CommonContainer
        class="analysis"
        :scale="styleContainer.topChartStyle"
        :title="$store.state.pieTitle"
        @handleTypesSelect="handleTypesSelected"
        @change="changeisShowChart"
      >
        <!-- <template slot-scope="scope">
          <BarChart
            ref="理论"
            :bar-data="categoryData.理论"
            :is-show-legend-default="scope.chartStatus.isShowEnlargedChart"
            v-if="scope.chartStatus.isShowChart"
          ></BarChart>
          <DetailTable
            :type-list="checkedSubcategoryNameList.理论"
            :table-data="tableData.理论"
            v-else
          ></DetailTable>
        </template> -->
        <PieCharts :echartsList="$store.state.piechartsList"></PieCharts>
      </CommonContainer>
    </div>

    <slot />

    <div class="topChart-wrap">
      <CommonContainer class="information-wrap" id="information-style">
        <main style="position: relative">
          <Search
            class="search-wrap"
            ref="searchRef"
            @search="search"
            @searchEnter="searchEnter"
          />
          <!-- 有搜索记录才出来 -->
          <div class="history" v-if="pastHistory">
            <div class="hisText">历史记录</div>
            <div style="max-height: 80px; overflow: auto">
              <el-tag
                style="margin: 10px 10px 0 0; cursor: pointer"
                v-for="(item, index) in searchRefList"
                :key="index"
                @click="clickHistory(item, index)"
                closable
                @close="deleteHis(index)"
                :title="item"
                size="small"
              >
                {{ item }}
              </el-tag>
            </div>
          </div>
          <!-- <div class="hisText_right">
          <span>排序：</span>
           <span
                @click="timeSort"
                :class="{ blue: activeSort == 'timeSort' }"
                >时间<i
                  v-if="activeSort == 'timeSort'"
                  :class="{
                    'el-icon-bottom': !this.orderId,
                    'el-icon-top': this.orderId,
                  }"
                ></i
              ></span>
              <span
                @click="relevanceSort"
                :class="{ blue: activeSort == 'relevanceSort' }"
                >相关度<i
                  v-if="activeSort == 'relevanceSort'"
                  :class="{
                    'el-icon-bottom': !this.orderId,
                    'el-icon-top': this.orderId,
                  }"
                ></i
              ></span>
        </div> -->
          <InformationList
            :information-data="testData"
            :scale="{ width: '95%' }"
            :search-name="searchName"
            @informationCard="informationCard"
          />
          <el-pagination
            style="position: absolute; bottom: -23px"
            small
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-size="pageSize"
            layout="total, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </main>
      </CommonContainer>
    </div>
  </main>
</template>

<script>
import CommonContainer from "@/components/CommonContainer";
import BarChart from "@/components/Charts/BarChart";
// import LineChart from "@/components/Charts/LineChart"
// import PieChart from "@/components/Charts/PieChart"
// import RadarChart from "@/components/Charts/RadarChart"
import DetailTable from "@/components/Tables/DetailTable";
import BarEcharts from "@/components/EchartsAnalysis/barEcharts"; // 媒体资讯
import PieCharts from "@/components/EchartsAnalysis/pieEcharts"; // 情绪
import Search from "@/components/Search";
import InformationList from "@/components/InformationList";
import { service, request } from "@/utils/request";
import "./topChart.scss";

export default {
  props: {
    newRecords:{ 
      type: Object,
      require: true,
    },
    categoryData: {
      type: Object,
      require: true,
    },
    tableData: {
      type: Object,
      require: true,
    },
    subcategoryNameList: {
      type: Object,
      require: true,
    },
    checkedSubcategoryNameList: {
      type: Object,
      require: true,
    },
  },
  components: {
    CommonContainer,
    BarChart,
    BarEcharts, // 媒体资讯
    PieCharts, // 情绪
    // LineChart,
    // PieChart,
    // RadarChart,
    DetailTable,
    InformationList,
    Search,
  },
  data() {
    return {
      activeSort: "",
      orderId: 0,
      // records:[],
      searchRefList: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      searchName:"",
      pastHistory: true, //搜索记录
      testData: [],
      mapContainer: {
        mapTitle: "地图",
        selectedRegion: [],
      },
      styleContainer: {
        topChartStyle: { width: "22vw", height: "29vh" },
        topElectricChartStyle: { width: "22vw", height: "50vh" },
        footerChartStyle: { width: "47vw", height: "29vh" },
        chartScale: { width: "100%", height: "100%" },
      },
      barData: [
        {
          name: "2011",
          data: {
            Brazil: 18203,
            Indonesia: 23489,
            USA: 29034,
            India: 104970,
          },
        },
        // {
        //   name: "2012",
        //   data: {
        //     Brazil: 19325,
        //     Indonesia: 23438,
        //     USA: 31000,
        //     India: 121594,
        //   },
        // },
      ],
      lineData: [
        {
          name: "2011",
          data: {
            Brazil: 18203,
            Indonesia: 23489,
            USA: 29034,
            India: 104970,
          },
        },
        // {
        //   name: "2012",
        //   data: {
        //     Brazil: 19325,
        //     Indonesia: 23438,
        //     USA: 31000,
        //     India: 121594,
        //   },
        // },
      ],
    };
  },
  computed: {
    watchSystemType() {
      return this.$store.getters.getSystemType;
    },
    records(){
      return this.$store.state.cardInformationList
    }
  },
  watch: {
    watchSystemType: function (n) {
      console.log(`watch value ${n}`);
    },
    newRecords(oldvalue,newval){
      this.testData = []
      this.newRecords.records.forEach((b) => {
            this.testData.push({
              cardTitle: b.information.title,
              cardContent: b.information.short_content,
              href: b.information.link,
              the_time: b.information.the_time,
              id: b.information.id,
            });
          });
        this.total = this.newRecords.total_records
    }
  },
  mounted() {
    this.getRegionInformation();
    let localhistory = localStorage.getItem("historyList");
    localhistory = JSON.parse(localhistory);
    this.searchRefList = localhistory;
    //  const records = this.$store.state.cardInformationList.records;
    //       records.forEach((b) => {
    //         this.testData.push({
    //           cardTitle: b.information.title,
    //           cardContent: b.information.short_content,
    //           href: b.information.link,
    //           the_time: b.information.the_time,
    //         });
    //       });
    // this.total =this.$store.state.cardInformationList.total_records;
    
  },
  methods: {
     // 时间排序
    // timeSort() {
    //   this.activeSort = "timeSort";
    //   // datetime
    //   this.order = "datetime";
    //   this.orderId = Number(!this.orderId);
    //   // this.handleSearch();
    // },
    // // 相关度排序
    // relevanceSort() {
    //   this.activeSort = "relevanceSort";
    //   // relevance
    //   this.order = "relevance";
    //   this.orderId = Number(!this.orderId);
    //   // this.handleSearch();
    // },
    informationCard(item){
      console.log(item);
    },
       /**
     * 点击搜索事件
     * @param data 搜索框输入
     */
    search(data) {
      this.searchName = data;
      this.isSearch = true;
      this.currentPage = 1;
      this.testData = [];
      this.getSearchData();
      this.saveHistory(data);
    },
    searchEnter(e, data) {
      if (e.keyCode == 13) {
        this.searchName = data;
        this.isSearch = true;
        this.currentPage = 1;
        this.testData = [];
        this.getSearchData();
        this.saveHistory(data);
      }
    },
    // 去重方法封装
    unique(arr) {
      return arr.filter(function (item, index, arr) {
        return arr.indexOf(item, 0) === index;
      });
    },
    // 排序
    saveHistory(data) {
      if (this.searchRefList !== null) {
        this.searchRefList.unshift(data);
      } else {
        this.searchRefList = [];
        this.searchRefList.push(data);
      }

      this.searchRefList = this.unique(this.searchRefList);

      if (this.searchRefList.length > 10) {
        //最多保存10条
        this.searchRefList = this.searchRefList.slice(0, 10);
      }
      localStorage.setItem("historyList", JSON.stringify(this.searchRefList)); //存localStorage
      this.pastHistory = true;
    },
    //点击删除记录
    deleteHis(index) {
      if (isNaN(index) || index >= this.searchRefList.length) {
        return false;
      }
      this.searchRefList.splice(index, 1);

      localStorage.setItem("historyList", JSON.stringify(this.searchRefList)); //保存删除后的新数组
      if (this.searchRefList.length === 0) {
        this.pastHistory = false;
      }
    },
     // 点击历史记录直接搜索
    clickHistory(data) {
      this.search(data);
      this.$refs.searchRef.searchdata = data;
    },
    changeisShowChart(val) {
      this.$emit("change", val);
    },
    handleTypesSelected(obj) {
      this.$parent.handleTypesSelected(obj);
    },
 
    /**
     * 获取后端数据
     */
    getServiceData() {
      return service.api;
    },
    /**
     * 点击地图接口
     */
    getRegionInformation() {
      let domainId = 1;
      if (this.$store.getters.getSystemType == "海洋信息") {
        domainId = 1;
      } else {
        domainId = 2;
      }
      let regionMapId = !this.$store.getters.getRegionMap[this.mapName]? 223 : this.$store.getters.getRegionMap[this.mapName]
      let is_domestic = false;
      if (regionMapId >= 192) {
        is_domestic = true;
      }
      request.region_information
        .find("", {
          domain_id: domainId,
          is_domestic: is_domestic,
          region_id: this.$store.getters.getRegionMap[this.mapName] || 223,
          category_code: "1.",
          page_size: this.pageSize,
          page_to: this.currentPage,
        })
        .then((res) => {
          this.testData = [];
          const records = res.data.data.records;
          if(records.length<1){
            this.$message.info("暂无该信息!")
          }
          records.forEach((b) => {
            this.testData.push({
              cardTitle: b.information.title,
              cardContent: b.information.short_content,
              href: b.information.link,
              the_time: b.information.the_time,
            });
          });
          this.total = res.data.data.total_records;
        });
    },
    /**
     * 点击搜索接口
     */
   getSearchData() {
      let domainId = 1;
      if (this.$store.getters.getSystemType == "海洋信息") {
        domainId = 1;
      } else {
        domainId = 2;
      }
      let regionMapId = this.$store.getters.getRegionMap[this.mapName];
      let is_domestic = false;
      if (regionMapId >= 192) {
        is_domestic = true;
      }
       if(this.searchName === "台湾"){
        is_domestic = true;    
      }
      request.region_information
        .find("", {
         
          domain_ids: domainId,
          is_domestic: is_domestic,
          // region_id: this.$store.getters.getRegionMap[this.mapName] || 140,
          category_code: "1.",
          page_size: this.pageSize,
          page_to: this.currentPage,
          search: this.searchName,
        })
        .then((res) => {
          const records = res.data?.data?.records;
          if(records.length<1){
            this.$message.info("暂无该信息!")
          }
          this.testData = [];
          records.forEach((b) => {
            this.testData.push({
              cardTitle: b.information.title,
              cardContent: b.information.short_content,
              href: b.information.link,
              the_time: b.information.the_time,
            });
          });
          this.total = res.data.data.total_records;
        });
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      if (!this.isSearch) {
        this.getRegionInformation();
      } else {
        this.getSearchData();
      }
    },
  },
};
</script>
<style  lang="scss">
$wrapHeight: 80vh;
$mapWidth: 60vw;
$fontColor: #eee;
.information-wrap {
  // width: calc(100% - 60vw - 100px); // $mapWidth: 60vw;
  height: $wrapHeight;
  main {
    width: 100%;
    height: 100%;
    position: absolute;
    display: flex;
    flex-direction: column;
    // justify-content: space-around;
    align-items: center;

    .search-wrap {
      margin: 10px 0;
      width: 80%;
    }
  }
}
.history {
  width: 80%;
  li {
    display: flex;
    width: 80%;
    justify-content: space-between;
    height: 10%;
  }
}
</style>
<style scoped>
.analysis{
  height: 41vh!important;
}
#information-style{
  height:89vh!important;
}
</style>